import { useMediaQuery as useMediaQueryHook } from 'usehooks-ts'
import { styles } from '@signavio/ui'

type MediaQueryOptions = {
  maxWidth?: number
  minWidth?: number
}

const getQuery = ({ maxWidth, minWidth }: MediaQueryOptions) => {
  if (maxWidth && minWidth) {
    return `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`
  }
  if (maxWidth) {
    return `(max-width: ${maxWidth}px)`
  }
  if (minWidth) {
    return `(min-width: ${minWidth}px)`
  }
  return ''
}

export const useMediaQuery = (options: MediaQueryOptions) =>
  useMediaQueryHook(getQuery(options))

const useMedia = () => {
  const isXs = useMediaQuery({ maxWidth: styles.media.xsMax })
  const isSm = useMediaQuery({ maxWidth: styles.media.smMax })
  const isMd = useMediaQuery({ maxWidth: styles.media.mdMax })
  const isLg = useMediaQuery({ minWidth: styles.media.lgMin })
  const isXl = useMediaQuery({ minWidth: 1801 })

  return { isXs, isSm, isMd, isLg, isXl }
}

export default useMedia
